import { useQuery } from '@tanstack/react-query';
import { SearchResponse, BaseParams, SearchQuery, Emojis } from '@/client';
import { apiReturnResults } from '@/client/apiFactory/apiReturn';

const callSearchEmoji = (params: BaseParams<SearchQuery>) =>
    apiReturnResults<SearchResponse>(Emojis.Emoji.search, params);
export function useGetEmojiDetails(emojiID = '') {
    return useQuery(
        ['emoji-search', emojiID],
        ({ signal }) => callSearchEmoji({ settings: { signal }, query: { emoji_id: emojiID } }),
        {
            enabled: Boolean(emojiID?.length),
            keepPreviousData: true,
            retry: true,
        },
    );
}
